import { ApplicationState } from 'app/types-store';

export const selectSelectionReportInstanceState = (instanceKey: string) => (state: ApplicationState) =>
  state.selectionReport.instances[instanceKey];

export const selectAggregateFieldState = (instanceKey: string) => (state: ApplicationState) =>
  state.selectionReport.instances[instanceKey]?.aggregateFieldState;

export const selectGroupByFieldState = (instanceKey: string) => (state: ApplicationState) =>
  state.selectionReport.instances[instanceKey]?.groupByFieldState;

export const selectTargetFieldState = (instanceKey: string) => (state: ApplicationState) =>
  state.selectionReport.instances[instanceKey]?.targetFieldState;

export const selectDistributionFieldState = (instanceKey: string) => (state: ApplicationState) =>
  state.selectionReport.instances[instanceKey]?.distributionFieldState;

export const selectChartState = (instanceKey: string) => (state: ApplicationState) =>
  state.selectionReport.instances[instanceKey]?.chartState;

export const selectSelectionReportExecuteStatus = (instanceKey: string) => (state: ApplicationState) =>
  state.selectionReport?.instances?.[instanceKey]?.chartState?.executeStatus;
